import { css } from "styled-components";

const reportsButton = css`
  svg  { 
    fill: #fff; 
    stroke: #fff 
  }
  
  path { 
    fill: #fff; 
    stroke: #fff 
  }

  rect { 
    fill: #fff; 
    stroke: #fff 
  }
`;
export default reportsButton;
